import React from 'react';
import clsx from 'clsx';
import { IProps } from './StoriesDetailLayout.interface';
import { renderBlock } from '@/app/index';
import './StoriesDetailLayout.styles.css';
import { storiesDetailBlockProps } from '@/blocks/MetaDataBlock/MetaDataBlock.props';

export const StoriesDetailLayout: React.FC<IProps> = ({
  left = [{ name: 'MetaDataBlock', props: storiesDetailBlockProps }],
  right,
  layout = 'right',
  className,
}) => {
  const layoutClasses = {
    left: 'storiesDetailLayout__layout--left',
    right: 'storiesDetailLayout__layout--right',
    half: 'storiesDetailLayout__layout--half',
  };

  return (
    <div
      className={clsx(
        'storiesDetailLayout',
        className,
        'storiesDetailLayout__layout',
        layoutClasses[layout],
      )}
    >
      <div className="storiesDetailLayout__column--left">
        {left?.map((block, index) => renderBlock(block, index))}
      </div>
      <div className="storiesDetailLayout__column--right">
        {right?.map((block, index) => renderBlock(block, index))}
      </div>
    </div>
  );
};
